import type { VideoContentObject } from 'models';
import { useEffect, useRef } from 'react';

type P = {
  isContentObjectLoading: boolean;
  isFetchingFull: boolean;
  isFetchingTrailer: boolean;
  isLoadingFull: boolean;
  isLoadingTrailer: boolean;
  videoContentObject?: VideoContentObject;
};

export const useIsSkeletonVisible = ({
  isContentObjectLoading,
  isFetchingFull,
  isFetchingTrailer,
  isLoadingFull,
  isLoadingTrailer,
  videoContentObject,
}: P) => {
  const wasSkeletonHidden = useRef(false);

  /* eslint-disable react-hooks/refs -- Start: fix later */
  const isSkeletonVisible =
    !videoContentObject ||
    isContentObjectLoading ||
    (((isLoadingTrailer && isFetchingTrailer) || (isLoadingFull && isFetchingFull)) && !wasSkeletonHidden.current);

  useEffect(() => {
    if (!isSkeletonVisible) {
      wasSkeletonHidden.current = true;
    }
  }, [wasSkeletonHidden, isSkeletonVisible]);
  /* eslint-enable react-hooks/refs -- End: fix later */

  // eslint-disable-next-line react-hooks/refs -- TODO: fix later
  return isSkeletonVisible;
};
